<p-dialog
  [visible]="visible()"
  (visibleChange)="visibleChange.emit($event)"
  [modal]="true"
  [style]="{ width: '28rem' }"
  [header]="message() ? getTitle(message()!) : ''"
>
  @if (message(); as message) {
    <ul class="flex flex-col gap-1 mb-3">
      @if (isSnapshot(message)) {
        @for (item of snapshotList(message); track item.field) {
          <li class="text-sm">
            <span class="font-medium"
              >{{ fieldLabel(item.field) | translate }}:</span
            >
            {{ formatChangeValue(item.field, item.value) }}
          </li>
        }
      } @else {
        @for (change of changesList(message); track change.field) {
          <li class="text-sm">
            <span class="font-medium"
              >{{ fieldLabel(change.field) | translate }}:</span
            >
            {{ formatChangeValue(change.field, change.from) }} →
            {{ formatChangeValue(change.field, change.to) }}
          </li>
        }
      }
    </ul>
    <p
      class="text-sm whitespace-pre-line text-surface-700 dark:text-surface-300"
    >
      {{ 'messages.detail.justification' | translate }}:
      {{
        message.content.justification ||
          ('messages.detail.no_justification' | translate)
      }}
    </p>
    <p class="text-xs text-surface-400 mt-3">
      {{ 'messages.detail.changed_by' | translate }}:
      {{ message.content.changedByName || '-' }}
    </p>
    <p class="text-xs text-surface-400">
      {{ message.createdAt | date: 'dd/MM/yyyy HH:mm' }}
    </p>
    <p class="text-xs text-surface-400 mt-3 italic">
      {{ 'messages.detail.disclaimer' | translate }}
    </p>
  }

  <div class="flex justify-end pt-4">
    <p-button
      [label]="'messages.detail.close' | translate"
      severity="secondary"
      [outlined]="true"
      (click)="onClose()"
    />
  </div>
</p-dialog>
